import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements AfterViewInit {
  @ViewChild('carousel') carousel!: ElementRef;
  @ViewChild('prevBtn') prevBtn!: ElementRef;
  @ViewChild('nextBtn') nextBtn!: ElementRef;
  @ViewChild('bullets') bullets!: ElementRef;

  private currentIndex: number = 0;
  private slides: HTMLElement[] = [];
  private totalSlides: number = 0;

  ngAfterViewInit() {
    this.slides = Array.from(this.carousel.nativeElement.children);
    this.totalSlides = this.slides.length;
    this.updateCarousel();
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.updateCarousel();
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.updateCarousel();
  }

  private updateCarousel() {
    this.carousel.nativeElement.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    const bulletElements = this.bullets.nativeElement.children;
    for (let i = 0; i < bulletElements.length; i++) {
      bulletElements[i].classList.toggle('bg-gray-400', i !== this.currentIndex);
      bulletElements[i].classList.toggle('bg-primary-500', i === this.currentIndex);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateCarousel();
  }
}